import { PDFOutputPreviewDialogService } from './../components/dialogs/pdf-output-preview-dialog/pdf-output-preview-dialog-service';
import { AppContext } from 'src/app/types/app-context';
import { ModalMessagerService } from './../modal-messager/modal-messager.service';
import { SLContext } from 'src/app/types/sl-context';
import { Injectable } from '@angular/core';
import { PDFDocument, StandardFonts, rgb, degrees, PDFPage, PDFImage } from 'pdf-lib'
import html2canvas from 'html2canvas';

@Injectable({
  providedIn: 'root'
})
export class PdfExportService {
  static ScreenUnitPerInch: number;
  static PageUnitPerInch = 72;
  static PagePerScreen: number;
  static ScreenPerPage: number;

  constructor() {
  }
  static SetUnits() {
    // if (!!PdfExportService.ScreenUnitPerInch) return;
    const e = document.body.appendChild(document.createElement('DIV'));
    e.style.width = '1in';
    e.style.padding = '0';
    PdfExportService.ScreenUnitPerInch = e.offsetWidth;
    PdfExportService.ScreenPerPage = PdfExportService.ScreenUnitPerInch / PdfExportService.PageUnitPerInch;
    PdfExportService.PagePerScreen = PdfExportService.PageUnitPerInch / PdfExportService.ScreenUnitPerInch;

    e.parentNode.removeChild(e);
    return PdfExportService.ScreenUnitPerInch;
  }

  static SubsetCanvas(canvas: HTMLCanvasElement, x, y, width, height) {
    PdfExportService.SetUnits();

    // create an in-memory canvas
    var buffer = document.createElement('canvas');
    var b_ctx = buffer.getContext('2d',{ willReadFrequently: true });

    // set its width/height to the required ones
    buffer.width = width;
    buffer.height = height;
    // draw the main canvas on our buffer one
    // drawImage(source, source_X, source_Y, source_Width, source_Height,
    //  dest_X, dest_Y, dest_Width, dest_Height)
    b_ctx.drawImage(canvas, x, y, width, height,
      0, 0, buffer.width, buffer.height);
    return buffer.toDataURL();
  }
  static SetPageSize(page: PDFPage, width_in: number, height_in: number) {
    page.setSize(width_in * PdfExportService.PageUnitPerInch, height_in * PdfExportService.PageUnitPerInch);
  }
  static async Export(context: SLContext) {
    PdfExportService.SetUnits();




    const pdfDoc = await PDFDocument.create();
    const timesNewRoman = await pdfDoc.embedFont(StandardFonts.TimesRoman);

    const page = pdfDoc.addPage();
    PdfExportService.SetPageSize(page, 8.5, 11);
    page.setRotation(degrees(-90))

    const { width, height } = page.getSize()
    const widthInch = width / PdfExportService.PageUnitPerInch;
    const heightInch = height / PdfExportService.PageUnitPerInch;
    const minPageInch = Math.min(widthInch, heightInch);

    const canvas = context.map.ui.getCanvas() as HTMLCanvasElement;
    const quarterPageInch = .25 * PdfExportService.PageUnitPerInch;
    const halfPageInch = .5 * PdfExportService.PageUnitPerInch;


    // context.map.ui.style.transform = 'scale(2)';
    const minDim = PdfExportService.ScreenUnitPerInch * minPageInch;
    const minScreenDim = Math.min(canvas.width, canvas.height);
    const squareDim = minDim < minScreenDim ? minDim : minScreenDim;
    const squareDimPage = squareDim * PdfExportService.PagePerScreen;
    let x = ((canvas.width / 2.0) - (squareDim / 2.0));
    let y = ((canvas.height / 2.0) - (squareDim / 2.0));
    console.log(x, y);
    const data = PdfExportService.SubsetCanvas(canvas, x, y, squareDim, squareDim);

    const img = await pdfDoc.embedPng(data);
    const scaled = img.scaleToFit(612 - halfPageInch, 612 - halfPageInch);
    page.drawImage(img, {
      x: width - scaled.height - quarterPageInch,
      y: height - quarterPageInch,
      width: scaled.width,
      height: scaled.height,
      rotate: degrees(-90),
      opacity: 1
    });


    const pdfBytes = await pdfDoc.save({});
    (context as AppContext).GetMessager().RequestExport({
      extension: 'pdf',
      mimeType: 'application/pdf',
      contents: pdfBytes,
      defaultFileName: 'example'
    }, 'Save as PDF');
  }
  static ExportBuffer(context: AppContext, _buffer: HTMLCanvasElement, orientation = 'landscape') {
    PDFDocument.create().then((pdf: PDFDocument) => {
      pdf.embedPng(_buffer.toDataURL()).then((img: PDFImage) => {
        const page = pdf.addPage();

        let pageWidth = 0;
        let pageHeight = 0;
        if (orientation === 'landscape') {
          pageWidth = 72 * 11;
          pageHeight = 72 * 8.5;
          PdfExportService.SetPageSize(page, 11, 8.5);

        } else {
          pageWidth = 72 * 8.5;
          pageHeight = 72 * 11;
          PdfExportService.SetPageSize(page, 8.5, 11);
        }
        const scaled = img.scaleToFit(pageWidth, pageHeight);
        page.drawImage(img, {
          x: 0,
          y: 0,
          width: scaled.width,
          height: scaled.height,
          opacity: 1
        });
        pdf.save({}).then((bytes) => {
          (context as AppContext).GetMessager().RequestExport({
            extension: 'pdf',
            mimeType: 'application/pdf',
            contents: bytes,
            defaultFileName: 'example'
          }, 'Save as PDF');

        })

      })

    });

  }
}
